/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ManageUserModel {

        public searchCriteria: UserSearchCriteria;
        public users: Wars.Domain.Model.Dtos.UserDto[];
        public editUser: Wars.Domain.Model.Dtos.UserDto;
        public systemClaims: Wars.Domain.Model.ClaimDefinition[];
        public claimDefinitionSelected: Wars.Domain.Model.ClaimDefinition;
        public claimValue: string;
       
        constructor(
            private userService: services.UserService,
            private systemLevelService: services.SystemLevelService)
        {
            this.systemLevelService = systemLevelService;
            this.searchCriteria = new UserSearchCriteria();
            this.editUser = undefined;
        }

        public clearSearchCriteria() : void {
            this.searchCriteria = new UserSearchCriteria();
        }

        public search(): void {
            var self = this;
            //this.userService.search(this.searchCriteria).then(
            //    (users: Wars.Domain.Model.Dtos.UserDto[]) => {
            //        self.users = users;
            //    });
        }

        public editSelectedUser(index: number) {
            var self = this;
            self.editUser = self.users[index];
            //self.systemLevelService.getSystemLevelClaimsWithGrantAuthorizations().then((systemLevel) => {
                //self.userService.getSystemClaimsForUser(self.editUser);
                //self.systemClaims = self.filterAlreadyAssignedClaims(systemLevel, self.editUser);
            //});
        }

        private filterAlreadyAssignedClaims(systemLevel: Wars.Domain.Model.SystemLevel, user: Wars.Domain.Model.Dtos.UserDto) {
            //var filteredClaims = [];
            //for (var i = 0; i < systemLevel.myClaims.length; i++) {
            //    var pushClaim = true;
            //    for (var ii = 0; ii < user.userClaims.length; ii++) {
            //        if (systemLevel.myClaims[i].claimMapName != null && systemLevel.myClaims[i].claimMapName.trim() !== "") {
            //            //mapped claim
            //            pushClaim = false;
            //            break;
            //        }
            //        if (systemLevel.myClaims[i].id === user.userClaims[ii].claimDefinition_id) {
            //            pushClaim = false;
            //            break;
            //        }
            //    }
            //    if (pushClaim) {
            //        filteredClaims.push(systemLevel.myClaims[i]);
            //    }
            //}
            //return filteredClaims;
        }

        public toggleIsActive() {
            this.systemLevelService.saveAllChanges();
        }

        public userClaimFilter(userClaim: Wars.Domain.Model.Dtos.UserClaimDto) {
            //return userClaim.claimDefinition && userClaim.claimDefinition.processConfiguration_id == null;
        }

        public userSystemClaims(): Wars.Domain.Model.Dtos.UserClaimDto[] {
            //if (!this.editUser || !this.editUser.userClaims) return [];
            //return Enumerable.from(this.editUser.userClaims).where(i => this.userClaimFilter(i)).toArray();
            return undefined;
        }

        public addNewUserClaim() : void {
            //var self = this;
            //var newUserClaim = self.userService.createNewUserClaim(self.editUser);
            //newUserClaim.claimDefinition = self.claimDefinitionSelected;
            //newUserClaim.userAssignedValue = self.claimValue;
            //self.editUser.userClaims.push(newUserClaim);
            //self.userService.saveAllChanges(() => {
            //    self.claimDefinitionSelected = undefined;
            //    self.claimValue = undefined;
            //    self.systemLevelService.getSystemLevelClaims().then((systemLevel) => {
            //        self.systemClaims = self.filterAlreadyAssignedClaims(systemLevel, self.editUser);
            //    });
            //});
        }

        public deleteClaim(index: number) {
            //var self = this;
            //var systemClaims = self.userSystemClaims();
            //systemClaims[index].entityAspect.setDeleted();
            //self.userService.saveAllChanges(() => {
            //    self.systemLevelService.getSystemLevelClaims().then((systemLevel) => {
            //        self.systemClaims = self.filterAlreadyAssignedClaims(systemLevel, self.editUser);
            //    });
            //});
        }
    }
}